import { render } from "./Tanjant.vue?vue&type=template&id=9321f65e"
import script from "./Tanjant.vue?vue&type=script&lang=js"
export * from "./Tanjant.vue?vue&type=script&lang=js"

import "./Tanjant.vue?vue&type=style&index=0&id=9321f65e&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__